module.exports = __webpack_public_path__ + "static/media/nike-eor-lost-1.84ee9c9b.jpg";